import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * UserPreferences API shell — endpoints are injected from userPreferencesQueries.ts and
 * userPreferencesMutations.ts. This keeps each file focused while sharing a single
 * reducer, middleware, and cache.
 */
export const userPreferencesApi = createApi({
  reducerPath: 'userPreferencesApi',
  baseQuery: createAuthenticatedBaseQuery(apiBaseUrl, 'User Preferences API'),
  tagTypes: ['UserPreferences'],
  endpoints: () => ({}),
});
